import * as React from 'react';

import constants from '@/constants';
import InfoCard from '@/screens/PHR/components/InfoSection/InfoCard';

import utils from '@/utils';
import i18n from '@/utils/translations/i18n';
import { Button, Dropdown } from 'antd';
// import { useNavigate } from 'react-router-dom';
import { SideContext } from '../..';
import BaseIconSvg from '@/components/bases/BaseIconSvg';
import { usePhrStoreInContext } from '@/stores/phr';
import quickModal from '@/utils/quickModal';
import InfoDetail from '@/screens/PHR/components/InfoSection/InfoDetail';
import useActions from '@/hooks/useActions';

export interface IInfoSectionProps {
  onChange: Function;
  collapsed: boolean;
  setCollapsed: Function;
}
export interface IKeyValueProps {
  keyName: string;
  value: any;
  key?: any;
}

export function BaseItemKeyValue(props: IKeyValueProps) {
  return (
    <div className="bg-white rounded-lg px-4 py-3 flex justify-between mb-1">
      <div>{props?.keyName}</div>
      <div className="font-bold">{props?.value}</div>
    </div>
  );
}

export default function InfoSection({ onChange, collapsed, setCollapsed }: IInfoSectionProps) {
  const phr = usePhrStoreInContext((s) => s.phr);
  const { isCollapsed } = React.useContext(SideContext);
  const { isCMSView } = useActions();

  //   const navigate = useNavigate();

  const user = phr?.user;

  const age = utils.getAge(user?.birthday);
  const members = user?.family?.members || [];
  const allMember = utils.filterArray([user?.family?.protector, ...members]);

  return (
    <>
      <div className="relative">
        <Dropdown
          trigger={['click']}
          menu={{
            items: isCMSView
              ? []
              : allMember.map((u: any) => ({
                  label: <InfoCard className={user?._id === u._id ? 'bg-mint-1' : ''} user={u} />,
                  key: u._id,
                })),
            onClick: async ({ key: uid }) => {
              if (
                (uid !== user?._id && !document.querySelectorAll('.base-modal')?.length) ||
                (await quickModal.confirm({
                  content: 'Khi chuyển user các cửa sổ sẽ bị đóng lại, bạn có chắc chắn muốn chuyển',
                }))
              ) {
                onChange();
                // navigate(`/phr/${uid}`);
                window.location.href = `/phr/${uid}`;
              }
            },
          }}
        >
          <div>
            <InfoCard
              user={user}
              className="cursor-pointer"
              collapsed={collapsed}
              isProtector={user?._id === user?.family?.protector?._id}
            />
          </div>
        </Dropdown>
        <Button
          className="absolute top-1/2 right-0 -translate-y-1/2 p-1 rounded-r-none border-none"
          onClick={() => setCollapsed(!collapsed)}
        >
          <BaseIconSvg src={collapsed ? '/icons/Light/Angle Right - icon.svg' : '/icons/Light/Angle Left - icon.svg'} />
        </Button>
      </div>

      <div className="px-4 py-2 relative">
        <div
          className={`flex items-center text-sm cursor-pointer ${collapsed ? 'justify-center' : 'justify-between'}`}
          onClick={() => {
            quickModal.custom({
              width: 600,
              title: 'Thông tin cá nhân',
              content: <InfoDetail user={user as IUser} />,
            });
          }}
        >
          <div className="items-center flex gap-2">
            <BaseIconSvg
              src={
                user?.gender === constants.GENDER.male
                  ? '/icons/Regular/male - icon.svg'
                  : user?.gender === constants.GENDER.female
                    ? '/icons/Regular/female - icon.svg'
                    : ''
              }
              className="wh-[16px]"
            />
            {isCollapsed
              ? null
              : i18n.t(`common.gender.${user?.gender}`, {
                  defaultValue: '-',
                })}
          </div>
          {isCollapsed
            ? null
            : [
                <div className="flex items-center gap-2" key="birthday">
                  <BaseIconSvg src="/icons/Solid/Birthday.svg" className="wh-[16px]" />
                  {age}
                </div>,
                <div className="flex items-center gap-2" key="blood group">
                  <BaseIconSvg src="/icons/Regular/Blood - icon.svg" className="wh-[16px]" />
                  {user?.bloodType || '-'}
                </div>,
              ]}
        </div>
      </div>
    </>
  );
}
